<template>
  <div class="donator_step1">
   <div class="container">
   	<div class="row">
   		<div class="col-md-4 offset-md-4">
        <h3>Stap 1</h3>
   			<h1>Uw bedrag</h1>
        <p>Kies het bedrag dat u eenmalig wilt overmaken.</p>
   			<form action="">
          <div class="form-group">
            <div v-on:click="setAmount(5)" class="button" v-bind:class="{'active': amount5 }">&euro;5</div>
            <div v-on:click="setAmount(10)" class="button" v-bind:class="{'active': amount10 }">&euro;10</div>
            <div v-on:click="setAmount(20)" class="button" v-bind:class="{'active': amount20 }">&euro;20</div>
            <div v-on:click="setAmount(25)" class="button" v-bind:class="{'active': amount25 }">&euro;25</div>
            <div v-on:click="setAmount(50)" class="button" v-bind:class="{'active': amount50 }">&euro;50</div>
          </div>
   				<div class="form-group">
   					<input type="text" name="amount" id="amount" placeholder="Anders.." class="form-control" v-model="amount">
   				</div>
          <div class="form-group">
            <select name="project" id="project" class="form-control" v-model="research_item">
              <option v-for="research_m in research" :value="research_m.title.rendered">{{ research_m.title.rendered }}</option>
            </select>
          </div>
   				<router-link :to="{ name: 'Donate_step2', params: { amount: amount, research_item: research_item } }"><button>Volgende stap</button></router-link>
   			</form>
   		</div>
   	</div>
   </div>
  </div>
</template>

<script>
export default {
  name: 'Donate_step1',
  data(){
    return {
      amount: '',
      research_item: '',
      amount5: false,
      amount10: false,
      amount20: false,
      amount25: false,
      amount50: false,
      research: []
    }
  },
  created: function(){
    this.$http.get('wp/v2/research').then(response => {
      this.research.push({ 'title' : { 'rendered' : 'Alle Projecten' }});
      for(let research_member in response.data){
        this.research.push(response.data[research_member]);
      }
    }, error => {
      alert(error);
    })
  },
  methods: {
    setAmount : function(amount){
      this.amount = amount;
      switch(amount){
        case 5:
        this.amount5 = true;
          break;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/donate/Step1.vue